/**
 * Decodes a query-string value that carries base64url UTF-8 JSON, as emailed links to
 * /workorderapi and /claimantapi do.
 */
export function DecodeLinkPayload(param) {
  const b64 = param.replace(/-/g, '+').replace(/_/g, '/');
  const bytes = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
  return JSON.parse(new TextDecoder().decode(bytes));
}

// Senders vary in key casing (ClmId / clmId, RemIntflg / RemIntFlg), so match keys case-insensitively.
export function CaseInsensitive(obj) {
  const byLower = {};
  Object.keys(obj || {}).forEach((key) => {
    byLower[key.toLowerCase()] = obj[key];
  });
  return (name) => byLower[name.toLowerCase()];
}
